import { getLinkWithAdvCode } from './get-link-with-adv-code';

interface INewHref {
    advCodes: string[];
    href: string;
}

// Обогащаем ссылку квери-параметрами
export const getNewHref = ({ advCodes, href }: INewHref): string =>
    advCodes.reduce(
        (newHref, advCodeName) => getLinkWithAdvCode({ advCodeName, link: newHref }),
        href
    );
